import React from "react";
import CustomSelect from "../common/Select";

const opcionesEtnia = [
  { value: "01", label: "INDIGENA" },
  { value: "02", label: "ROM (GITANO)" },
  { value: "03", label: "RAIZAL" },
  { value: "04", label: "PALENQUERO" },
  { value: "05", label: "NEGRO" },
  { value: "06", label: "AFROCOLOMBIANO" },
  { value: "99", label: "NINGUNA DE LAS ANTERIORES" }
];

function SelectorEtnia({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesEtnia}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Etnia"
      error={error}
      required={required}
    />
  );
}

export default SelectorEtnia;